import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { playerPropertiesSelector } from '../selectors/properties';
import { CC_INDEX_SET } from './types';

// The payload schema to make sure that the payload has the correct information
const payloadSchema = Joi.object().keys({
  ccMenuSelectedIndexes: Joi.array().required(),
});

// Creates the action with the action type and the payload schema
const playerCCMenuSetIndexAction = actionCreator(CC_INDEX_SET, payloadSchema);

// Does the calculations and make sure the index is correct before dispatching the action
// Payload is the index you want to set it to
export const playerCCMenuSetIndexThunkAction = (payload) => async (dispatch, getState) => {
  const state = getState();

  const { currentCCMenu: ccMenu, ccMenuSelectedIndexes: menuIndexes } = playerPropertiesSelector(
    state,
  );
  const newIndex = [...menuIndexes];
  let newIndexVal = payload;

  // if the payload is less than 0 set it to the last index of the menu
  if (newIndexVal < 0) {
    newIndexVal = ccMenu.length - 1;
  }

  // if the paylod is more than the last index of the menu then reset it to 0
  if (newIndexVal > ccMenu.length - 1) {
    newIndexVal = 0;
  }
  newIndex[newIndex.length - 1] = newIndexVal;
  dispatch(playerCCMenuSetIndexAction({ ccMenuSelectedIndexes: newIndex }));
};
